import React from 'react';

import { BackgroundRemovalModalComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

const globalLegacyI18n = window && window.globalLegacyI18n;

export const BackgroundRemovalModalPage = props => (
  <BackgroundRemovalModalComponent {...props} notificationApi={notificationApi} globalLegacyI18n={globalLegacyI18n} />
);
